import * as types from 'modules/toast-notifications/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {import('./types').Notification} Notification
 * @typedef {Array<Notification>} State
 */

/** @type {State} */
const initialState = [];

/**
 * @param {State} state
 * @param {import('modules/global/generic.types').Action<Notification>} action
 * @returns {State}
 */
const enqueue = (state, { payload }) => [...state, payload];

/**
 * @param {State} state
 * @returns {State}
 */
const dequeue = state => state.slice(0, -1);

const toastNotificationsReducer = createReducer(initialState, {
  [types.ENQUEUE_NOTIFICATION_TOAST]: enqueue,
  [types.DEQUEUE_NOTIFICATION_TOAST]: dequeue,
});

export default toastNotificationsReducer;
